import Menu from "@/shared/navigation/menu";
import { useNavigationItems } from "../../features/navigation/model/use-navigation-items";

export const MobileMenu = function () {
  const items = useNavigationItems();

  return <Menu items={items} mode="inline" />;
};
